import { RoutePath } from '@constants/routes';
import logger from './logger';
class WhatsAppSDK {
    constructor() {
        this.embeddedSignupData = null;
        this.setupMessageListener();
    }

    // Setup message event listener for WhatsApp Embedded Signup
    setupMessageListener() {
        window.addEventListener('message', event => {
            if (!event.origin.endsWith('facebook.com')) return;
            try {
                const data = JSON.parse(event.data);
                if (data.type === 'WA_EMBEDDED_SIGNUP') {
                    this.embeddedSignupData = data;
                }
            } catch {
                // Ignore parsing errors
            }
        });
    }

    // WhatsApp uses the same Facebook SDK that's already initialized in the app
    // So we don't need a separate init() method

    getLoginStatus() {
        return new Promise(resolve => {
            if (window.FB) {
                window.FB.getLoginStatus(response => {
                    resolve(response);
                });
            } else {
                logger.error('Facebook SDK not loaded');
                resolve({ status: null });
            }
        });
    }

    // WhatsApp Embedded Flow login
    loginWhatsApp() {
        return new Promise(resolve => {
            if (window.FB) {
                const redirectUri = `${window.location.origin}${RoutePath.AccountSettingsIntegrations}/`;

                window.FB.login(
                    response => {
                        resolve(response);
                    },
                    {
                        config_id: '1463341721482488', // WhatsApp Embedded Flow configuration ID
                        response_type: 'code',
                        auth_type: 'rerequest',
                        override_default_response_type: true,
                        redirect_uri: redirectUri,
                        extras: { version: 'v5' },
                    },
                );
            } else {
                logger.error('Facebook SDK not loaded');
                resolve({ error: 'Facebook SDK not loaded' });
            }
        });
    }

    getEmbeddedSignupSession() {
        const data = this.embeddedSignupData?.data;
        return {
            wabaId: data?.messaging_account_ids?.[0] || data?.waba_id || '',
            phoneNumberId: data?.phone_number_id || '',
            businessId: data?.business_id || '',
            isOnBusinessApp:
                data?.is_on_biz_app === true ||
                this.embeddedSignupData?.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING',
        };
    }

    // Clear the embedded signup data
    clearEmbeddedSignupData() {
        this.embeddedSignupData = null;
    }
}

export default new WhatsAppSDK();
